import React from 'react'
import { Card, Button, Row, Form, message } from 'antd'
import { SchemaForm } from 'xadmin-form'
import { pwdPage } from '../schema'
import { Icon, C } from 'xadmin-ui';
import LogoComponent from './LogoComponent'
import { app, api, use } from 'xadmin'
import _ from 'lodash';
import sha1 from 'crypto-js/sha1'

const DefaultLayout = props => {
  const { children, invalid, handleSubmit, onDelete, schema, submitting } = props;
  // console.log(props)
  const { _t } = app.context;
  return (
    <Form className="form-horizontal" onSubmit={handleSubmit} layout="vertical">
      <Card style={{ marginTop: 0, borderTop: 'none' }}>
        {children}
        <Row>
          <Button type="primary" className="loginBtn"  onClick={handleSubmit} disabled={invalid}>{_t('修改密码')}</Button>
        </Row>
      </Card>
    </Form>
  );
}

const PwdPage = props => {
  let id = props?.location?.query?.id
  const { user } = use('redux', state => ({ user: state.user }))

  React.useEffect(() => {
    const locaPathname = window.location.pathname
    let localUrl =`${user.username}${locaPathname}pwdTimeouttime`
    let pwdTimeouttime = localStorage.getItem(localUrl)

    if(localUrl && localUrl.includes(`${user.username}/admin`)) {
      let string = localUrl.replace(`${user.username}/admin`, `${user.username}`)
      let pwdTimeout = localStorage.getItem(string)
      if(pwdTimeout && pwdTimeouttime && !_.isEqual(pwdTimeout, pwdTimeouttime)) app.go('/login')
    } else {
      let string = localUrl.replace(`${user.username}`, `${user.username}/admin`)
      let pwdTimeout = localStorage.getItem(string)
      if(pwdTimeout && pwdTimeouttime && !_.isEqual(pwdTimeout, pwdTimeouttime)) app.go('/login')
    }
  }, [ user ])

  const onSubmit = (value) => {
    api({ name: 'core/user' }).fetch(`/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ 
        id, ...value,
        password: sha1(value.password).toString(),
        password2: sha1(value.password2).toString()
      })
    }).then(() => {
       message.success('修改密码成功')
       app.go('/login')
    })
  }

  return (
    <div className="setGuideCard">
      <div className="guideContent" style={{ width: '648px', margin: '0 auto', borderRadius: '5px' }}>
        <div style={{ maxWidth: '688px', background: 'rgba(255,255,255,.1)', padding: '28px' }}>
          <div style={{ maxWidth: '648px', background: 'rgba(255,255,255,.26)', padding: '28px' }}>
            <div className="loginGuide" >
              <div className="loginBox">
                <p className="guideUse">修改密码</p>
              </div>
              <SchemaForm
                formKey={'pwdPage'}
                schema={pwdPage}
                component={DefaultLayout}
                group={C('Form.SimpleGroup')}
                onSubmit={(value)=>onSubmit(value)}
              />
              <div className="loginBox">
                <p className="goReg" style={{ marginTop: 0 }} onClick={()=>app.go('/login')}>已修改，去登陆<Icon type="arrow-right" /></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PwdPage
